import { TFunction } from 'i18next';
import dayjs from 'dayjs';

export const monthKeyOf = (year: number, month: number) => `${year}-${String(month).padStart(2, '0')}`;

/** "avgust", lowercase, in the panel's language - the name the month stepper shows. */
export const monthName = (key: string): string => dayjs(`${key}-01`).format('MMMM').toLowerCase();

/** "u avgustu" / "in August": Serbian needs the locative, which no date library gives. */
export const inMonth = (t: TFunction, key: string): string => t(`finance.months.in.${Number(key.slice(5, 7))}`);

/** "za avgust" / "for August". */
export const forMonth = (t: TFunction, key: string): string => t('finance.months.for', { month: monthName(key) });
